import TagManager from "react-gtm-module";

const GTM_ID = process.env.REACT_APP_GTM_ID;

TagManager.initialize({
  gtmId: GTM_ID,
  auth: process.env.REACT_APP_GTM_AUTH,
  preview: process.env.REACT_APP_GTM_PREVIEW,
  dataLayer: {
    environment: process.env.REACT_APP_ENV
  }
});

export const pushGTMEvent = (event, data = {}) => {
  TagManager.dataLayer({
    dataLayer: {
      event,
      ...data
    }
  });
};
